import React from 'react';

export const HighlightText = ({ text, filters }) => {
    if (!filters?.highlight || !filters?.keywords?.length || !text) return text;
    try {
        const pattern = new RegExp(`(${filters.keywords.map(k => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`, 'gi');
        return text.split(pattern).map((part, i) =>
            filters.keywords.some(k => k.toLowerCase() === part.toLowerCase()) ?
                <mark key={`${i}-${part}`} className="bg-yellow-200 text-gray-900 rounded-sm px-0.5">{part}</mark> : part
        );
    } catch { return text; }
};
